@use "../../styles/breakpoint.module.scss" as *;

.grid {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: var(--spacer-48) var(--spacer-32);
    margin-top: var(--spacer-40);

    @media ($below-tablet) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.picture {
    display: block;
    width: 100%;
    aspect-ratio: 4 / 3;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.label {
    margin-bottom: var(--spacer-12);
    font: var(--font-eyebrow-12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.caption {
    margin-top: var(--spacer-12);
    font: var(--font-p-16);
}
